<template>
  <step-container
    title="Cuéntanos sobre el/la protagonista de la Memooria"
    class="scroll-m-40"
    :number="stepNumber"
  >
    <div class="w-full">
      <div class="mx-auto max-w-md flex flex-col gap-2">
        <div class="flex gap-4 justify-between">
          <ValidationProvider
            name="firstName"
            :rules="{ required: true }"
            v-slot="{ errors }"
            class="flex-auto"
          >
            <text-input-group
              ref="firstNameInput"
              label="Nombre"
              placeholder="Nombre"
              type="text"
              name="firstName"
              v-model="firstName"
              required
            />
            <div class="h-4 text-xs text-red-600">{{ errors[0] }}</div>
          </ValidationProvider>
          <ValidationProvider
            name="lastName"
            :rules="{ required: true }"
            v-slot="{ errors }"
            class="flex-auto"
          >
            <text-input-group
              ref="lastNameInput"
              label="Apellido"
              placeholder="Apodo"
              type="text"
              name="lastName"
              v-model="lastName"
              required
            />
            <div class="h-4 text-xs text-red-600">{{ errors[0] }}</div>
          </ValidationProvider>
        </div>

        <ValidationProvider name="nickname" v-slot="{ errors }">
          <text-input-group
            placeholder="Apodo"
            class=""
            type="text"
            name="nickname"
            label="Apodo"
            v-model="nickname"
          />
          <div v-if="errors.length" class="h-4 text-xs text-red-600">{{ errors[0] }}</div>
        </ValidationProvider>

        <div class="text-center mt-8 min-h-11">
          <styled-button
            v-if="!completed"
            title="Continuar"
            :disabled="!protagonistInfoValid"
            @click="handleContinue"
          />
        </div>
      </div>
    </div>
  </step-container>
</template>

<script>
import stepMixin from "../../mixins/step";
import optionMixin from "../../mixins/option";

import { ValidationProvider } from "vee-validate";
import "../../../../../utils/inputValidationRules";
import TextInputGroup from "../TextInputGroup.vue";
import StyledButton from "../layouts/StyledButton.vue";

export default {
  mixins: [stepMixin, optionMixin],
  inject: ["isPriceHidden", "loginPath"],
  components: { TextInputGroup, ValidationProvider, StyledButton },
  props: {
    value: {
      type: Object,
      required: true,
    },
    handleProtagonistInfoCompleted: {
      required: true,
    },
  },
  computed: {
    protagonistInfoValid() {
      return !!this.firstName && !!this.lastName;
    },
  },
  methods: {
    handleContinue() {
      this.completed = true;
      this.handleProtagonistInfoCompleted();
    },
  },
  data() {
    return {
      firstName: this.value.protagonistFirstName,
      lastName: this.value.protagonistLastName,
      nickname: this.value.protagonistNickname,
      completed: false,
    };
  },
  watch: {
    firstName(value) {
      this.$emit("input", { ...this.value, protagonistFirstName: value });
    },
    lastName(value) {
      this.$emit("input", { ...this.value, protagonistLastName: value });
    },
    nickname(value) {
      this.$emit("input", { ...this.value, protagonistNickname: value });
    },
  },
};
</script>
